<template>
	<div
		class="permissions-container"
		:class="{ expanded: expanded }"
		data-cy="permissions"
	>
		<header>
			<div class="header-contents">
				<div>
					<div class="title">{{ $t('groupsettings_permissions_title') }}</div>
					<div class="desc">
						{{ $t('groupsettings_permissions_control_description') }}
					</div>
				</div>
				<Button
					large
					@click="expanded = !expanded"
					data-cy="permissions-toggle"
					>{{
						expanded ? $t('common_button_collapse') : $t('common_button_expand')
					}}</Button
				>
			</div>
		</header>
		<div class="permissions">
			<PermissionSelector
				v-for="permission in permissions"
				:key="permission.id"
				:chat_id="chat.id"
				:permission="permission"
				@change="updatePermission(permission.id, $event)"
			/>
		</div>

		<div class="permissions-tip">
			<i18n-t keypath="groupsettings_permissions_manage_description">
				<template #PeopleScreen>
					<RouterLink
						:to="{ name: 'grouppeople', params: $route.params }"
						class="link-to-people"
					>
						{{ $t('groupsettings_permissions_description_peoplescreen') }}
					</RouterLink>
				</template>
			</i18n-t>
		</div>
	</div>
</template>

<script>
import store from '@/store'
import PermissionSelector from '@/components/GroupSettings/PermissionSelector'
import { Button } from '@/components/common'
import { updateChat } from '@/api/chat'
import {
	ASSIGN_TASK,
	CREATE_ANNOUNCEMENT,
	CREATE_POLLS,
	PIN_MESSAGE,
	CREATE_MESSAGE,
	UPDATE_TITLE,
	UPDATE_CATEGORY,
	CREATE_MEMBERSHIPS,
	DELETE_MEMBERSHIPS,
	DELETE_OWN_MEMBERSHIP,
	CREATE_MEETING,
	RECORD_MEETINGS,
} from '@/helpers/permissions'

const allPermissions = [
	{
		id: UPDATE_TITLE,
		label: 'groupsettings_permissions_changeTitle',
		tooltip: 'groupsettings_permissions_changeTitle_description',
	},
	{
		id: UPDATE_CATEGORY,
		label: 'groupsettings_permissions_changeCategory',
		tooltip: 'groupsettings_permissions_changeCategory_description',
	},
	{
		id: CREATE_MEMBERSHIPS,
		label: 'groupsettings_permissions_addMember',
		tooltip: 'groupsettings_permissions_addMember_description',
	},
	{
		id: DELETE_MEMBERSHIPS,
		label: 'groupsettings_permissions_removeMember',
		tooltip: 'groupsettings_permissions_removeMember_description',
	},
	{
		id: DELETE_OWN_MEMBERSHIP,
		label: 'groupsettings_permissions_leaveGroup',
		tooltip: 'groupsettings_permissions_leaveGroup_description',
	},
	{
		id: CREATE_MEETING,
		label: 'groupsettings_permissions_create_videosession',
		tooltip: 'groupsettings_permissions_create_videosession_description',
	},
	{
		id: CREATE_MESSAGE,
		label: 'groupsettings_permissions_create_message',
		tooltip: 'groupsettings_permissions_create_message_description',
	},
	{
		id: RECORD_MEETINGS,
		label: 'groupsettings_permissions_videoSessionRecordCloud',
		tooltip: 'groupsettings_permissions_videoSessionRecordCloud_description',
	},
	{
		id: ASSIGN_TASK,
		label: 'groupsettings_permissions_assign_task',
		tooltip: 'groupsettings_permissions_assign_task_description',
	},
	{
		id: CREATE_ANNOUNCEMENT,
		label: 'groupsettings_permissions_create_announcement',
		tooltip: 'groupsettings_permissions_create_announcement_description',
	},
	{
		id: PIN_MESSAGE,
		label: 'groupsettings_permissions_pin_message',
		tooltip: 'groupsettings_permissions_pin_message_description',
	},
	{
		id: CREATE_POLLS,
		label: 'Create polls',
		tooltip: 'TODO: add localized text for the tooltip',
	},
]

export default {
	components: {
		PermissionSelector,
		Button,
	},
	props: ['chat'],
	data() {
		return {
			store,
			allPermissions,
			expanded: false,
			saving: true,
			permissions: null,
		}
	},

	mounted() {
		allPermissions.forEach((permission) => {
			if (permission.id.includes('_')) {
				permission.grant = this.chat[`grant_${permission.id}`]
			} else {
				permission.grant = this.chat[`grant${permission.id}`]
			}
		})
		this.permissions = allPermissions.filter((p) => p.grant)
	},

	methods: {
		async updatePermission(permission, role) {
			try {
				await updateChat(this.chat.id, {
					permissions: {
						[permission]: role,
					},
				})
				this.$alert.success(
					this.$t('admin_people_changes_saved_confirmation_label')
				)
			} catch (e) {
				this.$alert.error(this.$t('common_api_error_save'))
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.permissions-container {
	border-radius: 4px;
	background: var(--neutral-100);
	border: 1px solid var(--neutral-200);
	// gotta fix this color ^
	padding: 12px 15px 11px 15px;
	max-height: 80px;
	transition: all 0.3s ease-in-out;
	overflow: hidden;
	&.expanded {
		max-height: 398px;
		// overflow: visible;
		//gotta fix this too^^^ It's goofy on the transition
	}
	header {
		display: flex;
		flex-direction: column;
		.header-contents {
			display: flex;
			align-items: center;
			justify-content: space-between;
			.title {
				font-family: map-get($fonts, 800);
				color: var(--neutral-800);
				margin-bottom: 4px;
			}
			.desc {
				color: var(--neutral-500);
				font-size: 14px;
			}
		}
		.pronto-btn {
			width: 170px;
			justify-content: center;
		}
	}
	.permissions {
		flex-direction: row;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		margin-top: 30px;
		row-gap: 10px;
	}
	.permissions-tip {
		margin-top: 20px;
		font-size: 14px;
		color: var(--neutral-500);
		.link-to-people {
			color: var(--teal-300);
			text-decoration: none;
		}
	}
}
</style>
